import React from "react";
import { HistoryIcon } from "./historyUtils";

/**
 * 16px line glyphs, drawn on `currentColor` so a row can tint them.
 * Phone for contact work, star for surveys, a reply-style arrow for referrals,
 * a document for files, a ticked box for Action Item tasks, a bell for
 * reminders, a dot for system, an envelope for email (direct 1:1 emails and
 * event/broadcast mail).
 */
const PATHS: { [key in HistoryIcon]: React.ReactNode } = {
  phone: (
    <path d="M4.6 2.6h2.2l1 2.5-1.4 1a7.6 7.6 0 0 0 3.5 3.5l1-1.4 2.5 1v2.2a1 1 0 0 1-1.1 1A10 10 0 0 1 3.6 3.7a1 1 0 0 1 1-1.1z" />
  ),
  star: <path d="M8 2.2 9.8 6l4.1.5-3 2.8.8 4.1L8 11.4l-3.7 2 .8-4.1-3-2.8L6.2 6z" />,
  ref: (
    <>
      <path d="M3 13.5V6.5A2.5 2.5 0 0 1 5.5 4H12" />
      <path d="M9.6 1.8 12.4 4 9.6 6.2" />
    </>
  ),
  doc: (
    <>
      <path d="M4 2h5l3 3v9H4z" />
      <path d="M9 2v3h3" />
    </>
  ),
  check: (
    <>
      <rect x="2.5" y="2.5" width="11" height="11" rx="1.6" />
      <path d="M5.2 8.2 7.3 10.3l3.6-4" />
    </>
  ),
  bell: (
    <>
      <path d="M4.2 11.2V7.4a3.8 3.8 0 0 1 7.6 0v3.8l1.2 1.3H3z" />
      <path d="M6.6 13.6a1.5 1.5 0 0 0 2.8 0" />
    </>
  ),
  dot: <circle cx="8" cy="8" r="2.6" />,
  mail: (
    <>
      <rect x="2" y="3.5" width="12" height="9" rx="1.4" />
      <path d="m2.6 4.4 5.4 4.2 5.4-4.2" />
    </>
  ),
};

export const RowIcon = ({ name }: { name: HistoryIcon }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-hidden="true"
    focusable="false"
    style={{
      flex: "none",
      stroke: "currentColor",
      fill: "none",
      strokeWidth: 1.4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
  >
    {PATHS[name]}
  </svg>
);

/** `›` that rotates to `⌄` once its row is open. */
export const Chevron = ({ open }: { open: boolean }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 16 16"
    aria-hidden="true"
    focusable="false"
    style={{
      flex: "none",
      stroke: "currentColor",
      fill: "none",
      strokeWidth: 1.4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transform: open ? "rotate(90deg)" : "none",
      transition: "transform 120ms ease",
    }}
  >
    <path d="M6 3.5 10.5 8 6 12.5" />
  </svg>
);
